import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/sections/HeroSection';
import DualModeSection from './components/sections/DualModeSection';
import PainPointsSection from './components/sections/PainPointsSection';
import ServicesSection from './components/sections/ServicesSection';
import AIFeatureSection from './components/sections/AIFeatureSection';
import TeamExpertiseSection from './components/sections/TeamExpertiseSection';
import PortfolioSection from './components/sections/PortfolioSection';
import BusinessScopeSection from './components/sections/BusinessScopeSection';
import PricingSection from './components/sections/PricingSection';
import ContactSection from './components/sections/ContactSection';
import FooterSection from './components/sections/FooterSection';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import DocumentHead from './components/DocumentHead';
import AdminApp from './admin/AdminApp';

function HomePage() {
  return (
    <div className="min-h-screen bg-deep-navy">
      <DocumentHead />
      <Header />
      <main>
        <HeroSection />
        <DualModeSection />
        <PainPointsSection />
        <ServicesSection />
        <AIFeatureSection />
        <TeamExpertiseSection />
        <PortfolioSection />
        <BusinessScopeSection />
        <PricingSection />
        <ContactSection />
      </main>
      <FooterSection />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin/*" element={<AdminApp />} />
    </Routes>
  );
}

export default App;
